import { BaseRouteProps } from '../types/route-props';
import { ProductsParametersApi } from '../types/api/products-parameters-api';
import { buildURL, isV3 } from '../common';
import { Method, callAxios } from '../axios';
import { getBrandName } from '../locale';

const getComparisonBundleURL = (contextRoot: string, languageCode: string, countryCode: string) => {
  const brand = getBrandName();
  if (isV3()) {
    return buildURL({
      host: process.env.API_HOST,
      endpoint: `/products-comparison/main?country-code=${countryCode}&language-code=${languageCode}&brand=${brand}`,
    });
  }

  return buildURL({
    host: process.env.API_HOST,
    contextRoot,
    countryCode,
    languageCode,
    endpoint: '/product/api/products/comparison/main',
  });
};

export const comparisonBundleProductsApiFetchers = {
  getComparisonBundleProductsFetcher: async ({
    contextRoot,
    countryCode,
    languageCode,
    params,
  }: BaseRouteProps & {
    params?: ProductsParametersApi.GetProductsParametersParams;
  }) => {
    const GET_COMPARISON_BUNDLE_PRODUCTS = getComparisonBundleURL(
      contextRoot,
      languageCode,
      countryCode,
    );
    const response = await callAxios<{
      response;
      params: typeof params;
    }>({
      method: Method.GET,
      url: GET_COMPARISON_BUNDLE_PRODUCTS,
      params,
    });

    return response.data;
  },
};
